import React, { useState, useMemo } from "react";
import GeoJsonWindow from "../components/GeoJsonWindow";
import D3MapWindow from "../components/D3MapWindow";
import OpenLayersMap from "../components/OpenLayersMap";

// List file names and their public paths
const files = [
  { name: "france1.geojson", path: "/data/france1.geojson" },
  { name: "Festival.geojson", path: "/data/Festival.geojson" },
  { name: "background.geojson", path: "/data/background.geojson" },
  // Add more files here if needed
];




const Francemap = () => {
  const [geojsons, setGeojsons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDisciplines, setSelectedDisciplines] = useState([]);
  // Extract unique disciplines from Festival.geojson (geojsons[1])
  const disciplines = useMemo(() => {
    if (!geojsons[1] || !geojsons[1].features) return [];
    const set = new Set();
    geojsons[1].features.forEach(f => {
      if (f.properties && f.properties.discipline) {
        f.properties.discipline.split(',').forEach(d => set.add(d.trim()));
      }
    });
    return Array.from(set).filter(Boolean).sort();
  }, [geojsons]);
  // Filter Festival features by selected disciplines
  const filteredFestivalGeojson = useMemo(() => {
    if (!geojsons[1] || !geojsons[1].features || selectedDisciplines.length === 0) return geojsons[1];
    return {
      ...geojsons[1],
      features: geojsons[1].features.filter(f => {
        if (!f.properties || !f.properties.discipline) return false;
        return selectedDisciplines.some(d => f.properties.discipline.includes(d));
      })
    };
  }, [geojsons, selectedDisciplines]);

  React.useEffect(() => {
    setLoading(true);
    setError(null);
    Promise.all(files.map(f => fetch(f.path).then(res => {
      if (!res.ok) throw new Error(`Failed to fetch ${f.name}`);
      return res.json();
    })))
      .then(dataArr => setGeojsons(dataArr))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  // Merge all features into one FeatureCollection for map display
  const mergedGeojson = geojsons.length > 0 ? {
    type: "FeatureCollection",
    features: geojsons.flatMap(g => g.features)
  } : null;

  return (
    <div style={{
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      background: 'linear-gradient(135deg, #800020 50%, #D4AF37 50%)',
      minHeight: '60vh',
      borderRadius: '20px',
      width: '100%',
    }}>
      <div style={{
        maxWidth: '1500px',
        margin: '0 auto',
        background: '#800020',
        borderRadius: '20px',
        padding: '30px',
        backdropFilter: 'blur(10px)'
      }}>
        <p style={{
          textAlign: 'center',
          color: '#D4AF37',
          marginBottom: '15px',
          fontSize: '3.5em',
          fontFamily: 'Broadway, sans-serif'
        }}>what
          Carte des festivals en France
        </p>
        {loading && <div>Loading...</div>}
        {error && <div style={{color: 'red'}}>Error: {error}</div>}
        {/* Map Container */}
        <div style={{
          borderRadius: '10px',
          overflow: 'hidden',
          background: '#800020',
        }}>
          {geojsons.length >= 2 && (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              {/* Sidebar for discipline filter */}
              <div style={{
                minWidth: 220,
                background: '#800020',
                borderRadius: '10px',
                marginRight: 24,
                padding: '18px 12px',
                maxHeight: 520,
                overflowY: 'auto',
                fontFamily: 'Broadway, sans-serif',
                fontSize: '1.2em',
                color: '#D4AF37',                marginTop: 10
              }}>
                <div style={{ fontWeight: 'bold', marginBottom: 10, fontSize: '1.1em' }}>Disciplines</div>
                <div>
                  {disciplines.map(d => (
                    <label key={d} style={{ display: 'block', marginBottom: 6, cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        checked={selectedDisciplines.includes(d)}
                        onChange={e => {
                          setSelectedDisciplines(sel =>
                            e.target.checked
                              ? [...sel, d]
                              : sel.filter(x => x !== d)
                          );
                        }}
                        style={{ marginRight: 8 }}
                      />
                      {d}
                    </label>
                  ))}
                </div>
                <button
                  style={{ marginTop: 10, background: '#D4AF37', color: '#800020', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer' }}
                  onClick={() => setSelectedDisciplines([])}
                  disabled={selectedDisciplines.length === 0}
                >
                  Clear disciplines
                </button>
              </div>
              {/* Map */}
              <div style={{ flex: 1 }}>
                <OpenLayersMap
                  layers={[
                    {
                      geojson: geojsons[2],   // bottom (world)
                      style: { fill: '#800020', stroke: '#ffffff00', strokeWidth: 2 }
                    },
                    {
                      geojson: geojsons[0],   // middle (eg mask / highlight)
                      style: { fill: '#a4163a', stroke: '#d4af3700', strokeWidth: 1 }
                    },
                    {
                      geojson: filteredFestivalGeojson || geojsons[1],   // top (France/festivals)
                      style: { fill: '#D4AF37', stroke: '#ffffff00', strokeWidth: 1 }
                    }
                  ]}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Francemap;
